<template>
  <div v-if="stockOrdersIn && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="stockOrdersIn"
    />
  </div>
</template>
<script>
import StockIns from "@/api/stock_in_orders";

import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import { mapState } from "vuex";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    stockOrdersIn: [],
  }),

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountInfo"]),
  },

  mounted() {
    PrintTemplates.fetchOne("stockOrderIn").then(
      function (response) {
        if (response.data.status.isOK()) {
          // console.log(response);
          var formater = response.data.print_template.print_template.template;
          this.formater = formater;

          //获取单据详情
          StockIns.stockOrdersInPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockOrdersIn = response.data.stock_ins;
                this.stockOrdersIn.forEach((stockOrder) => {
                  stockOrder.stock_order_details.map((detail) => {
                    if (detail.negotiate_price_flg == 1) {
                      // 显示后议价
                      detail.price = this.$t("PurchasesDetail.purchaseFields.negotiatePrices");
                    }
                    return detail;
                  });
                });
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  }

};
</script>